import Utils from "../utils/utils"

export type SearchResultType = "collection" | "resource"

export interface SearchSuggestion {
    text: string
    type: SearchResultType
}

export class SearchDocument {
    public title = ""
    public url = ""
    public posterImage = ""
    public objectType: SearchResultType = null
    public score: number = null

    constructor(input) {
        Object.keys(input).map((key) => {
            const property = key === "_score" ? "score" : Utils.convertToCamelcase(key)
            this[property] = input[key]
        })
    }
}

export class SearchDocumentCategory {
    public category = ""
    public documents: SearchDocument[] = []

    constructor(input) {
        this.category = input.category
        this.documents = (input.documents || []).map((document) => new SearchDocument(document))
    }
}

export interface SearchSuggestionsResponse {
    suggestions: SearchSuggestion[]
    documents: SearchDocumentCategory[]
}
